import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomButtonSwitchComponent } from './custom-button-switch.component';
import {CmsConfig, ConfigModule, I18nModule} from "@spartacus/core";
import {CustomIconsModule} from "../../../icons/custom-icons.module";
import {CustomButtonSwitchDirective} from "./custom-button-switch.directive";

@NgModule({
  declarations: [CustomButtonSwitchComponent, CustomButtonSwitchDirective],
  exports: [CustomButtonSwitchComponent, CustomButtonSwitchDirective],
  imports: [
    CommonModule,
    I18nModule,
    CustomIconsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ButtonSwitchBetweenMenuAndContentComponent: {
          component: CustomButtonSwitchComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomButtonSwitchModule { }
